module.exports = __webpack_public_path__ + "img/groupbuypage-sample.114d0251.jpg";